import React, { Component } from 'react';
import { TemplateComponent } from '../../components';
import s from './HostStyles.module.scss';

export default class TemplateComponentHost extends Component {
    constructor(props) {
        super(props);
        this.state = { foo: 'Foo' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <TemplateComponent foo={this.state.foo} />
            </div>
        );
    }
}
